import { css } from 'lit';
import componentStyles from '../../styles/component.styles';
export default css `
  ${componentStyles}
  /**
--------------------------------------------------
* General
--------------------------------------------------
*/
:host {
    display: block;
  }

  .color {
    height: 100%;
  }

  .content {
    padding-top: 1rem;
  }

  /**
--------------------------------------------------
* Display
--------------------------------------------------
*/

  .layout-default .display-color {
    aspect-ratio: 16/9;
    border-radius: var(--p-color-boxed-border-radius, 5px);
  }

  .layout-square:not(.table-view) .display-color {
    aspect-ratio: 1/1;
    border-radius: var(--p-color-boxed-border-radius, 5px);
  }

  .boxed:not(.table-view).layout-default .display-color,
  .boxed:not(.table-view).layout-square .display-color {
    border-radius: var(--p-color-boxed-border-radius, 5px) var(--p-color-boxed-border-radius, 5px) 0
      0;
  }

  .layout-circle .display-color {
    aspect-ratio: 1/1;
    border-radius: 50%;
  }

  .layout-circle.boxed .display {
    padding: 1rem 1rem 0rem 1rem;
  }

  /**
--------------------------------------------------
* Table view
--------------------------------------------------
*/
  .table-view {
    display: grid;
  }

  .table-view:not(.boxed) {
    gap: var(--p-color-table-padding, 0.75rem);
  }

  .table-view.boxed .display {
    padding: 1rem 1rem 1rem 1rem;
  }

  .table-view .display {
    display: flex;
    gap: var(--p-color-table-padding, 0.75rem);
  }

  .table-view .display-color {
    height: 3rem;
    aspect-ratio: 1/1;
  }

  .table-view.layout-square .display-color {
    border-radius: var(--p-color-boxed-border-radius, 5px);
  }

  .table-view .display-name {
    padding-top: 0.75rem;
    font-size: var(--p-font-size-normal);
  }

  .table-view .content {
    padding-top: 0;
    align-self: center;
  }

  @container (min-width: 800px) {
    .table-view {
      grid-template-columns: 35% 1fr;
    }
    .table-view .display {
      display: grid;
      grid-template-columns: 3rem 1fr;
    }
    .table-view.nameless {
      grid-template-columns: 5.5rem 1fr;
    }
    .table-view.nameless .display {
      grid-template-columns: 1fr;
    }
    .table-view.nameless .display-name {
      display: none;
    }
    .table-view .display-color {
      aspect-ratio: 1/1;
    }
    .table-view .values {
      grid-template-columns: repeat(2, 3.75rem 1fr);
      column-gap: 0.5rem;
    }
  }

  @container (min-width: 1200px) {
    .table-view {
      grid-template-columns: 26% 1fr;
      gap: 1rem;
    }
    .table-view .values {
      grid-template-columns: repeat(4, 3.75rem 1fr);
      column-gap: 0.5rem;
    }
  }

  /**
--------------------------------------------------
* Values
--------------------------------------------------
*/
  .values {
    display: grid;
    column-gap: 0.1rem;
    grid-template-columns: 3.75rem 1fr;
    font-size: 0.875rem;
  }

  .label {
    font-family: var(--p-font);
    padding-top: 0.25rem;
    line-height: normal;
  }

  button.value {
    border: none;
    background: none;
    appearance: none;
    color: var(--p-color-text);
    cursor: pointer;
    font-size: inherit;
    font-weight: inherit;
    padding: 0.25rem 0.5em;
    text-align: left;
    border-radius: 5px;
  }

  button.value:hover {
    background: var(--p-text-color-contrast-100);
  }

  button.value.success {
    color: var(--p-success);
    pointer-events: none;
  }

  /**
--------------------------------------------------
* Border
--------------------------------------------------
*/
  .border .display-color {
    border: 1px solid var(--p-border);
  }

  /* Boxed swatches sit flush against the card, so a full frame would double up
     on the card border. Only the dividing line towards the content is drawn. */
  .border.boxed:not(.table-view):not(.layout-circle) .display-color {
    border: none;
    border-bottom: 1px solid var(--p-border);
  }

  /**
--------------------------------------------------
* Boxed
--------------------------------------------------
*/
  .boxed {
    border: 1px solid var(--p-border);
    background-color: var(--p-boxed-bg);
    border-radius: var(--p-color-boxed-border-radius, 5px);
    overflow: hidden;
  }

  .boxed .content {
    padding: var(--p-color-boxed-padding, 1rem);
  }
`;
